import type { BeckyModel } from '@wix/thunderbolt-becky-root'
import type { RepeaterDataItem, Component } from '@wix/thunderbolt-becky-types'
import { getChildrenAndSlots } from '@wix/thunderbolt-catharsis'

export const REPEATER_DELIMITER = '__'

/** Returns repeaters item ids from DataMap. If component is not a repeater, returning undefined. */
function getRepeaterItems(component: Component, data: BeckyModel['data']): Array<string> | undefined {
	if (component.type !== 'RepeaterContainer') {
		return undefined
	}
	if (!component.dataQuery || !data.document_data[component.dataQuery]) {
		return []
	}
	return (data.document_data[component.dataQuery] as RepeaterDataItem).items
}

function createOverrideComponent(component: Component, itemId: string, data: BeckyModel['data']) {
	const repeaterSuffix = REPEATER_DELIMITER + itemId
	const repeaterItemComponent: Component = {
		...component,
		id: component.id + repeaterSuffix,
		type: component.type,
	}

	if (component.designQuery && data.design_data?.[component.designQuery + repeaterSuffix]) {
		repeaterItemComponent.designQuery += repeaterSuffix
	}
	if (component.dataQuery && data.document_data?.[component.dataQuery + repeaterSuffix]) {
		repeaterItemComponent.dataQuery += repeaterSuffix
	}
	return repeaterItemComponent
}

export function getComponentsWithRepeatedItems({
	structure,
	data,
	pageCompId,
}: Pick<BeckyModel, 'structure' | 'data' | 'pageCompId'>): Array<Component> {
	const resultComps: Array<Component> = Object.values(structure)
	const traverse = (compId: string, ancestorItems?: Array<string>) => {
		const component = structure[compId]
		if (!component) {
			return
		}
		const repeaterItems = getRepeaterItems(component, data) ?? ancestorItems
		const childComps = getChildrenAndSlots(component)
		childComps?.forEach((childId) => traverse(childId, repeaterItems))

		if (ancestorItems && (component.designQuery || component.dataQuery)) {
			ancestorItems.forEach((itemId: string) => {
				resultComps.push(createOverrideComponent(component, itemId, data))
			})
		}
	}
	traverse(pageCompId)
	return resultComps
}
